const types = {
    FETCH_PRODUCT_DETAILS: 'FETCH_PRODUCT_DETAILS',
    FETCH_PRODUCT_DETAILS_SUCCESS: 'FETCH_PRODUCT_DETAILS_SUCCESS',
    FETCH_PRODUCT_DETAILS_FAILED: 'FETCH_PRODUCT_DETAILS_FAILED',
    SHOW_LOADING_PRODUCT_DETAILS: 'SHOW_LOADING_PRODUCT_DETAILS',
};

export default types;